import axios from 'axios'

// app base url http config
const AppHttpConfig = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

AppHttpConfig.interceptors.request.use(async (config) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}')
  if (user?.accessToken) {
    (config.headers as any) = {
      authorization: `Bearer ${user?.accessToken}`,
    }
  }
  return config
})

// sso http config for login and get token
const SsoHttpConfig = axios.create({
  baseURL: process.env.REACT_APP_SSO_URL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
})

export { AppHttpConfig, SsoHttpConfig }
